/**
 * BrandBadge — the DomiOps mark: the "O" of DomiOps drawn as a ring that spins
 * at one constant speed and never stops. Pure SVG + CSS, crisp at any size.
 * `color` defaults to the app ink; pass "#fff" on dark surfaces.
 */
export default function BrandBadge({ size = 32, className = "", color = "#1d1d1f", style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      style={{ animation: "domiops-spin 1.4s linear infinite", ...style }}
      role="img"
      aria-label="DomiOps"
      data-testid="brand-badge"
    >
      <circle cx="50" cy="50" r="38" fill="none" stroke={color} strokeOpacity="0.14" strokeWidth="12" />
      <circle
        cx="50" cy="50" r="38" fill="none" stroke={color} strokeWidth="12" strokeLinecap="round"
        strokeDasharray="175 64" transform="rotate(-90 50 50)"
      />
      <style>{`@keyframes domiops-spin { to { transform: rotate(360deg); } }`}</style>
    </svg>
  );
}

/** Header wordmark: light "Domi" + spinning-O + bold "ps". Inherits the surrounding text colour
 * (so theme rules that recolour `.text-[#1d1d1f]` on navy/dark navs turn it white). */
export function Wordmark({ className = "", testId = "brand-wordmark" }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center leading-none tracking-tight select-none text-[#1d1d1f] ${className}`}
      style={{ fontFamily: 'Inter, -apple-system, "SF Pro Display", sans-serif', letterSpacing: "-0.03em" }}
      aria-label="DomiOps"
    >
      <span className="font-extralight">Domi</span>
      <svg viewBox="0 0 100 100" className="mx-[0.02em] h-[0.68em] w-[0.68em] self-end mb-[0.06em]" aria-hidden="true">
        <circle cx="50" cy="50" r="42.5" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="15" />
        <g style={{ animation: "domiops-spin 4.5s linear infinite", transformOrigin: "50% 50%" }}>
          <circle cx="50" cy="50" r="42.5" fill="none" stroke="currentColor" strokeWidth="15" strokeLinecap="round" strokeDasharray="160 107" transform="rotate(-90 50 50)" />
        </g>
      </svg>
      <span className="font-bold">ps</span>
      <style>{`@keyframes domiops-spin { to { transform: rotate(360deg); } }`}</style>
    </span>
  );
}
